export default "__VITE_ASSET__Cg3fKXeQ__"